import React from "react";

const Brandon = () => {
  return (
    <>
      <svg
        height="100%"
        viewBox="0 0 512 512"
        width="100%"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g id="filled_outline" data-name="filled outline">
          <path
            d="m328 352 117.955 65.531a60 60 0 0 1 30.259 43.969l3.786 26.5h-448l3.916-27.411a60 60 0 0 1 28.976-43.231l111.108-65.358z"
            fill="#eaeae8"
          />
          <path
            d="m152 200v-88a81.941 81.941 0 0 1 -24-57.941v-30.059l33.918 8.48a251.92 251.92 0 0 0 61.09 7.52h50.309a35.45 35.45 0 0 1 25.066 10.383l21.617 21.617a35.448 35.448 0 0 1 32.913 22.283 99.073 99.073 0 0 1 7.087 36.8v68.917z"
            fill="#683b0d"
          />
          <path
            d="m215.994 112a7.976 7.976 0 0 1 -3.572-.847l-17.689-8.844a33.7 33.7 0 0 1 -18.733-30.309 8 8 0 0 1 16 0 17.792 17.792 0 0 0 9.888 16l17.69 8.845a8 8 0 0 1 -3.584 15.155z"
            fill="#533222"
          />
          <path
            d="m255.994 112a7.976 7.976 0 0 1 -3.572-.847l-17.689-8.844a33.7 33.7 0 0 1 -18.733-30.309 8 8 0 0 1 16 0 17.792 17.792 0 0 0 9.888 16l17.69 8.845a8 8 0 0 1 -3.584 15.155z"
            fill="#533222"
          />
          <path
            d="m295.994 112a7.976 7.976 0 0 1 -3.572-.847l-17.689-8.844a33.7 33.7 0 0 1 -18.733-30.309 8 8 0 0 1 16 0 17.792 17.792 0 0 0 9.888 16l17.69 8.845a8 8 0 0 1 -3.584 15.155z"
            fill="#533222"
          />
          <path d="m296 328-8-16h-64l-8 16-8 8 48 40 48-38.4z" fill="#fdc9a6" />
          <path
            d="m294.36 324.73a70.918 70.918 0 0 1 -76.72 0l6.36-12.73h64z"
            fill="#e6af89"
          />
          <path
            d="m256 320a70.9 70.9 0 0 1 -65.827-44.567 198.156 198.156 0 0 1 -14.173-73.596v-57.837l24-40h112l24 40v57.837a198.156 198.156 0 0 1 -14.173 73.6 70.9 70.9 0 0 1 -65.827 44.563z"
            fill="#fdc9a6"
          />
          <g fill="#683b0d">
            <path d="m304 176h-24a8 8 0 0 1 0-16h24a8 8 0 0 1 0 16z" />
            <circle cx="290" cy="194" r="10" />
            <path d="m232 176h-24a8 8 0 0 1 0-16h24a8 8 0 0 1 0 16z" />
            <circle cx="222" cy="194" r="10" />
          </g>
          <path
            d="m247.994 272a8 8 0 0 1 -1.934-15.763l32-8a8 8 0 0 1 3.88 15.522l-32 8a8.007 8.007 0 0 1 -1.946.241z"
            fill="#e6af89"
          />
          <path
            d="m264 240h-16a8 8 0 0 1 -8-8v-24a8 8 0 0 1 16 0v16h8a8 8 0 0 1 0 16z"
            fill="#e6af89"
          />
          <path
            d="m176 168h-11.056a20.944 20.944 0 0 0 -20.944 20.944v14.112a20.944 20.944 0 0 0 2.211 9.366 20.944 20.944 0 0 0 18.733 11.578h19.056z"
            fill="#fdc9a6"
          />
          <path
            d="m336 168h11.056a20.944 20.944 0 0 1 20.944 20.944v14.112a20.944 20.944 0 0 1 -2.211 9.366 20.944 20.944 0 0 1 -18.733 11.578h-19.056z"
            fill="#fdc9a6"
          />
          <path d="m72 488v-32a8 8 0 0 1 16 0v32z" fill="#cbcbcb" />
          <path d="m424 488v-32a8 8 0 0 1 16 0v32z" fill="#cbcbcb" />
          <path d="m272 416h-32l-16-48 32 8 32-8z" fill="#0a9acd" />
          <path d="m240 416-8 72h48l-8-72z" fill="#0a9acd" />
          <path d="m273.78 432h-35.56l1.78-16h32z" fill="#0a9acd" />
          <path
            d="m400 464h-64a8 8 0 0 1 0-16h64a8 8 0 0 1 0 16z"
            fill="#cbcbcb"
          />
          <path d="m208 328 48 48-48 24-32-48z" fill="#cbcbcb" />
          <path d="m304 400-48-24 48-48 24 24z" fill="#cbcbcb" />
          <path d="m273.78 432h-35.56l1.78-16h32z" fill="#026ca2" />
          <path d="m280 176h24a8 8 0 0 0 0-16h-24a8 8 0 0 0 0 16z" />
          <circle cx="290" cy="194" r="10" />
          <path d="m232 160h-24a8 8 0 0 0 0 16h24a8 8 0 0 0 0-16z" />
          <circle cx="222" cy="194" r="10" />
          <path d="m287.761 254.06a8 8 0 0 0 -9.7-5.821l-32 8a8 8 0 1 0 3.88 15.522l32-8a8 8 0 0 0 5.82-9.701z" />
          <path d="m487.919 486.868-3.786-26.5a68.369 68.369 0 0 0 -34.293-49.826l-116.975-64.991-23.208-23.208a8 8 0 0 0 -8.457-1.831l-2.5-4.99a78.713 78.713 0 0 0 30.554-37.122 205.5 205.5 0 0 0 12.535-46.4h5.267a28.785 28.785 0 0 0 25.888-16 29.1 29.1 0 0 0 3.056-12.944v-14.112a28.834 28.834 0 0 0 -8.059-20.008 8.04 8.04 0 0 0 .059-.936v-36.919a106.624 106.624 0 0 0 -7.659-39.769 43.216 43.216 0 0 0 -36.893-27.178l-19.408-19.407a43.162 43.162 0 0 0 -30.724-12.727h-50.308a244.134 244.134 0 0 1 -59.15-7.281l-33.918-8.48a8 8 0 0 0 -9.94 7.761v30.059a89.31 89.31 0 0 0 24 61.168v52.773a8.04 8.04 0 0 0 .059.936 28.834 28.834 0 0 0 -8.059 20.008v14.112a29.1 29.1 0 0 0 3.056 12.944 28.785 28.785 0 0 0 25.888 16h5.267a205.5 205.5 0 0 0 12.535 46.4 78.713 78.713 0 0 0 30.554 37.122l-2.495 4.989a7.994 7.994 0 0 0 -7.6 1.089l-31.643 23.732-110.727 65.13a67.658 67.658 0 0 0 -32.838 49l-3.916 27.411a8 8 0 0 0 7.919 9.127h448a8 8 0 0 0 7.919-9.132zm-169.653-133.288-17.844 35.687-30.917-15.458 34.5-34.5zm-52.032 54.42h-20.468l-5.125-15.376 15.359-7.68 15.359 7.68zm93.766-204.944a13.017 13.017 0 0 1 -1.366 5.788 12.875 12.875 0 0 1 -11.578 7.156h-3.543q.48-7.05.487-14.163v-25.837h3.056a12.959 12.959 0 0 1 12.944 12.944zm-224-149v-19.81l23.978 5.994a260.04 260.04 0 0 0 63.03 7.76h50.308a27.266 27.266 0 0 1 19.41 8.04l21.617 21.617a8 8 0 0 0 5.657 2.343 27.319 27.319 0 0 1 25.486 17.254 90.7 90.7 0 0 1 6.514 33.827v29.35a28.987 28.987 0 0 0 -4.944-.431h-3.056v-16a8 8 0 0 0 -1.14-4.116l-24-40a8 8 0 0 0 -6.86-3.884h-14.112l-16-8a17.792 17.792 0 0 1 -9.888-16 8 8 0 0 0 -16 0 33.683 33.683 0 0 0 9.958 24h-8.07l-16-8a17.792 17.792 0 0 1 -9.888-16 8 8 0 0 0 -16 0 33.683 33.683 0 0 0 9.958 24h-8.07l-16-8a17.792 17.792 0 0 1 -9.888-16 8 8 0 0 0 -16 0 33.674 33.674 0 0 0 16.442 29.047l-23.3 38.837a8 8 0 0 0 -1.142 4.116v16h-3.056a28.987 28.987 0 0 0 -4.944.431v-48.431a8 8 0 0 0 -2.343-5.657 73.453 73.453 0 0 1 -21.657-52.284zm28.944 161.944a12.875 12.875 0 0 1 -11.578-7.156 13.017 13.017 0 0 1 -1.366-5.788v-14.112a12.959 12.959 0 0 1 12.944-12.944h3.056v25.837q0 7.113.487 14.163zm32.656 56.461a189.325 189.325 0 0 1 -13.6-70.624v-55.621l20.529-34.216h102.942l20.529 34.216v55.621a189.342 189.342 0 0 1 -13.6 70.626 62.9 62.9 0 0 1 -116.8 0zm58.4 55.539a79.246 79.246 0 0 0 28.433-5.246l4.412 8.824c.029.058.067.108.1.165l-32.945 32.943-32.943-32.943c.031-.057.069-.107.1-.165l4.412-8.824a79.246 79.246 0 0 0 28.431 5.246zm-48.75 10.563 35.25 35.246-31.756 15.878-23.885-35.828zm-163.415 123.158a51.74 51.74 0 0 1 25.113-37.468l104.59-61.524 27.806 41.709a8 8 0 0 0 10.234 2.717l14.607-7.3 5.67 17.011-7.015 63.134h-136.84v-24a8 8 0 0 0 -16 0v24h-30.776zm197.103 18.279 6.222-56h17.68l6.222 56zm199.062 0v-24a8 8 0 0 0 -16 0v24h-136.84l-7.015-63.137 5.67-17.011 14.607 7.3a7.993 7.993 0 0 0 10.733-3.577l20.264-40.527 110.651 61.475a52.287 52.287 0 0 1 26.224 38.1l2.482 17.377z" />
          <path d="m248 240h16a8 8 0 0 0 0-16h-8v-16a8 8 0 0 0 -16 0v24a8 8 0 0 0 8 8z" />
          <path d="m400 448h-64a8 8 0 0 0 0 16h64a8 8 0 0 0 0-16z" />
        </g>
      </svg>
    </>
  );
};

export default Brandon;
